export default __webpack_public_path__ + "static/media/3057653_media_payment_social_visa_icon-svg.940c0c66.svg";